//import Libraries
import React, {Component} from 'react';

//import Components
import Language from '../../../../language/language.json';

//import Style classes
import Icons from '../../../../assets/icons/icons';
import './ScrollDown.css'

class ScrollDown extends Component {
    // componentDidMount() {
    //     window.onscroll = () => {
    //         let currentY = window.scrollY ? window.scrollY : document.documentElement.scrollTop;
            
    //     }
    // }
    render(){
        return (
            <div id={"ScrollDown"} className={"ScrollDown"}>
                <p>{Language.scrolldown[this.props.universal.language]}</p>
                {Icons.scrolldown}
            </div>
        );
    }

}

export default ScrollDown;


// WEBPACK FOOTER //
// ./src/pages/Home/ScrollSection/ScrollDown/ScrollDown.js